import showMore from "../modules/show-more";

const initBlock = async function( block ) {
	showMore( block );
};

themeUtils.loadBlock( initBlock, "specific-dumpster-rental", ".section-specific-dumpster-rental" );
